<template>
  <v-container fluid fill-height align-start ma-0 pa-0>
    <v-card width="100%">
      <v-row no-gutters class="mt-5 mb-5">
        <v-col cols="12" class="d-flex">
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <span>
                <span>최종차수 : {{ highestOrgnVersion && highestOrgnVersion.orgnOrder != undefined ? highestOrgnVersion.orgnOrder : 'N/A' }}</span>
                <v-icon small color="primary" v-on="on">mdi-information-outline</v-icon>
              </span>
            </template>
            {{ '조직도중 가장 최근에 생성된 차수를 의미합니다. 확정되지 않은 최종차수 조직도만 수정 가능합니다.' }}
          </v-tooltip>
          <!--span style="margin-left: 100px;">수정일자 : {{ updateDt ? updateDt : '-' }}</span-->
          <v-spacer />
        </v-col>
      </v-row>
      <v-sheet width="100%" height="100%" class="overflow-hidden overflow-y-auto">
        <i-search-panel :searchPanel="searchPanel"></i-search-panel>
        <DxDataGrid
          id="dxDataGrid"
          class="layout-col-height02"
          width="100%"
          height="90%"
          :ref="dxDataGridRef"
          :data-source="orgnDatasource"
          :remote-operations="false"
          :hover-state-enabled="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          :column-auto-width="false"
          :show-borders="true"
          :show-row-lines="true"
          :selection="{ mode: 'single' }"
          key-expr="orgnOrder"
          :focused-row-enabled="true"
          :focused-row-index="0"
          @focused-row-changed="onFocusedRowChanged"
          @editing-start="onEditingStart"
          @row-updating="onRowUpdating"
          @editor-preparing="onEditorPreparing"
        >
          <DxPaging />
          <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

          <DxSelection select-all-mode="allPages" show-check-boxes-mode="always" mode="single" />
          <!-- <DxPager
                  :visible="pager.visible"
                  :allowed-page-sizes="pager.pageSizes"
                  :display-mode="pager.savigationMode"
                  :show-navigation-buttons="pager.showNavButtons"
          />-->
          <DxColumn
            data-field="orgnOrder"
            data-type="string"
            width="180px"
            alignment="center"
            caption="차수"
            sort-order="desc"
            :allow-editing="false"
            css-class="devest-grid-header"
          />
          <DxColumn
            data-field="view"
            data-type="string"
            width="70px"
            alignment="center"
            caption="보기"
            :allow-editing="false"
            :cell-template="'moveButton'"
            css-class="devest-grid-header"
          />

          <template #moveButton="{ data: cellInfo }">
            <v-btn v-if="cellInfo.data.__created__ != true" icon color="btn_sub" class="move" x-small @click="btnMoveOrgnVerlick(cellInfo)">
              <svg-icon icon-class="group"></svg-icon>
            </v-btn>
          </template>

          <DxColumn
            css-class="devest-grid-header-require"
            data-field="orgnOrderNm"
            data-type="string"
            width="180px"
            alignment="left"
            caption="차수명"
          />

          <DxColumn
            data-field="createdAt"
            data-type="string"
            :calculate-display-value="(e) => parseTime(e.createdAt, true)"
            width="200px"
            alignment="center"
            caption="생성일자"
            :allow-editing="false"
          />
          <DxColumn
            data-field="confirmYn"
            data-type="boolean"
            width="80"
            alignment="center"
            caption="확정여부"
            edit-cell-template="checkBoxEditor"
            :css-class="guideHighlightConfirm ? 'guide-blink-target' : ''"
          />
          <DxColumn
            data-field="confirmDt"
            data-type="string"
            :calculate-display-value="(e) => parseTime(e.confirmDt, true)"
            width="200px"
            alignment="center"
            caption="확정일자"
            :allow-editing="false"
          />
          <DxColumn data-field="diagramCnt" data-type="string" width="120" alignment="right" caption="조직인원(명)" />
          <DxColumn
            data-field="cancelDt"
            data-type="string"
            :calculate-display-value="(e) => parseTime(e.cancelDt, true)"
            width="200px"
            alignment="center"
            caption="취소일자"
            :allow-editing="false"
          />

          <!-- <DxColumn data-field="remark" data-type="string" width="100px" alignment="left" caption="비고" /> -->

          <template #checkBoxEditor="{ data: cellInfo }">
            <div>
              <div v-if="original != null && cellInfo.key != original.orgnOrder">
                <div v-if="cellInfo.key == highestOrgnVersion.orgnOrder && highestOrgnVersion.diagramCnt != 0 && !highestOrgnVersion.__created__">
                  <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :onValueChanged="(value) => onCheckValueChanged(value, cellInfo)" />
                </div>
              </div>
              <div v-else-if="highestOrgnVersion && cellInfo.key != highestOrgnVersion.orgnOrder">
                <DxCheckBox
                  :value="cellInfo.value == 'Y' ? true : false"
                  :onValueChanged="(value) => onCheckValueChanged(value, cellInfo)"
                  :disabled="true"
                  :read-only="true"
                />
              </div>
              <div v-else>
                <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :onValueChanged="(value) => onCheckValueChanged(value, cellInfo)" />
              </div>
            </div>
          </template>
        </DxDataGrid>
      </v-sheet>
    </v-card>
  </v-container>
</template>

<script>
import {
  //위험성평가 조직 마스터
  getRiskOrgnManageMaster,
  saveRiskOrgnManageMaster,
  deleteRiskOrgnManageMaster,
} from '@/api/riskAssessment/riskOrgnManage'
import iSearchPanel from '@/components/common/iSearchPanel.vue'
import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'

export default {
  mixins: [baseview, BaseDataGrid],
  name: 'RiskOrgnVerHistManage_VerHistory',
  components: { iSearchPanel },
  props: {
    guideHighlightConfirm: {
      type: Boolean,
      default: false,
    },
  },
  created() {},
  data() {
    return {
      dxDataGridRef: 'dxDataGrid',
      selectOrgnVerList: [], //[{ OrgnVerCd: '2022-04-01' }, { OrgnVerCd: '2022-04-02' }, { OrgnVerCd: '2022-04-03' }],
      selectedOrgnVersion: '',
      buttonOrgnVersionList: ['btnSearch', 'btnAdd', 'btnSave', 'btnDelete'],
      orgnDatasource: [],
      saveOrgnResultData: [],
      generatedID: 100,
      cusomeHrResourceVisible: true,
      original: null,
      searchPanel: true,
    }
  },
  computed: {
    getCheckStatus(dataField, data) {
      //////////console.log(dataField)
      if ((dataField == 'confirmYn' && data.cancelYn == 'Y') || (dataField == 'cancelYn' && data.confirmYn == 'Y')) return false
      else return true
    },
    highestOrgnVersion() {
      if (this.orgnDatasource == undefined || this.orgnDatasource.length == 0) return
      return this.orgnDatasource.reduce((a, b) => (a.orgnOrder > b.orgnOrder ? a : b))
    },
  },
  beforeMount() {
    ////////console.log('beforeMount')
    this.enableEditColumn = ['confirmYn', 'orgnOrderNm', 'remark']
    this.datagridRefs = [this.dxDataGridRef]
    //this.btnSearch()
  },
  mounted() {
    this.btnSearch()
  },
  methods: {
    //////////////////////////////////////////////////////////////////////////////////////////
    /*       Toolbar Button Event                                                           */
    //////////////////////////////////////////////////////////////////////////////////////////
    //------------------------------------------
    //조직 차수 이력 조회
    //------------------------------------------
    btnSearch() {
      if (this.comp == undefined) this.vSnackbar('필수조회조건이 없습니다.(compId)', 'error')
      this.openLoading('searching')
      let params = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
      }

      return getRiskOrgnManageMaster(params, true)
        .then((res) => {
          if (res.success) {
            this.gridInit(this.GetDataGrid(this.dxDataGridRef))
            this.orgnDatasource = res.list == undefined ? [] : res.list
            this.original = this.orgnDatasource.filter((element) => element.confirmYn == 'Y').reduce((a, b) => (a.orgnOrder > b.orgnOrder ? a : b))
            this.orgnDatasource.forEach((x) => (x.cancelYn = x.cancelDt != null ? 'Y' : 'N'))
            //focus the first row
            this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
            //포커스 된다고 선택되는건 아니니까..
            this.GetDataGrid(this.dxDataGridRef).selectRows(this.GetDataGrid(this.dxDataGridRef).getKeyByRowIndex(0), true)
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.endLoading()
        })
    },
    //------------------------------------------
    //조직 차수 추가
    //------------------------------------------
    btnAdd() {
      //마지막 차수가 확정상태가 아니면 추가할 수 없습니다.

      if (this.highestOrgnVersion && this.highestOrgnVersion.confirmYn != 'Y') {
        this.vSnackbar(`최종 차수 '${this.highestOrgnVersion.orgnOrder}'가 확정되지 않았습니다.`, 'warn')
        return
      }

      let newRow = {
        orgnOrder: 'insert-' + (this.orgnDatasource.length + 1),
        clntId: this.getClntId(),
        compId: this.comp.id,
        cancelYn: 'N',
        confirmYn: 'N',
        delYn: 'N',
      }

      console.log('newRow', newRow)

      Object.defineProperty(newRow, '__created__', { value: true, writable: true, enumerable: true, configurable: true })
      this.GetDataGrid(this.dxDataGridRef).newRow(newRow)
      this.GetDataGrid(this.dxDataGridRef).selectRows(newRow.orgnOrder, true)
    },
    //------------------------------------------
    //조직 차수 저장
    //------------------------------------------
    btnSave() {
      ////////console.log('btnSave')
      if (this.orgnDatasource.length <= 0) return
      let datasource = this.orgnDatasource
      let createdIndex = datasource.findIndex((data) => data.__created__)
      let row = {}
      if (createdIndex != -1) {
        row = datasource[createdIndex]
      } else {
        row = datasource[datasource.length - 1]
      }

      var pattern = /\s/g
      //입력값 Check
      console.log('@@ this.orgnDatasource', this.orgnDatasource)
      var index = datasource.findIndex(
        (element) => element.orgnOrder == null || element.orgnOrder.match(pattern) != null || element.orgnOrderNm == null
      )
      if (index >= 0) {
        this.vToastify(this.$t('필수항목 입력하세요.'), 'info')
        return
      }

      this.vToastifyPrompt(
        `[${row.orgnOrder}]<br/>${row.orgnOrderNm ? row.orgnOrderNm + '<br/>' : ''}차수이력을 저장하시겠습니까?`,
        'info',
        (current) => {
          this.openLoading()

          let tab2 = current.$refs['RiskOrgnVerHistManage']
          tab2.GetDataGrid(this.dxDataGridRef).saveEditData()
          //마지막 차수정보가 확정 -> 취소 되었다면 취소날짜 업데이트
          if (row.orgnOrder == this.highestOrgnVersion.orgnOrder && row.__created__ === false) {
            if (row.confirmYn == 'Y') row.cancelYn = 'N'
            else row.cancelYn = 'Y'
          }

          saveRiskOrgnManageMaster([row], true)
            .then((res) => {
              if (res.success) {
                this.endLoading()
                //console.log('success!!')
                tab2.gridInit(this.GetDataGrid(this.dxDataGridRef))
                //데이타 재조회

                tab2.btnSearch()
                tab2.$EventBus.$emit('OnsaveAndDeleteMaster')
                if (res.data && res.data == 99) {
                  this.vSnackbar(this.$t('조직도 데이터가 없으면 확정이 불가합니다. '), 'warn')
                }
              }
            })
            .catch((error) => {
              if (error.response && error.response.data) {
                if ([-6029, -6030, -6032].includes(error.response.data.code)) {
                  this.vSnackbar(`${row.orgnOrder}> ${error.response.data.msg}`, 'warn')
                  this.endLoading()
                }
              }
            })
            .finally(() => {
              return true
            })
        },
        null,
        true
      )
    },
    //------------------------------------------
    //조직 차수 삭제
    //------------------------------------------
    btnDelete() {
      //마지막 차수가 확정상태면 삭제할 수 없다
      if (this.orgnDatasource == undefined) return
      if (this.orgnDatasource.length <= 0) return

      let datasource = this.orgnDatasource
      let createdIndex = datasource.findIndex((data) => data.__created__)
      let row = {}
      if (createdIndex != -1) {
        row = datasource[createdIndex]
      } else {
        row = datasource[datasource.length - 1]
      }
      //유효성 체크 END ]]
      this.vToastifyPrompt(
        `[${row.orgnOrder}]<br/>${row.orgnOrderNm ? row.orgnOrderNm + '<br/>' : ''}차수이력을 삭제하시겠습니까?`,
        'info',
        (current) => {
          let tab2 = current.$refs['RiskOrgnVerHistManage']
          tab2.GetDataGrid(this.dxDataGridRef).saveEditData()

          row.updatedBy = tab2.getUserCd()

          //삭제 처리
          deleteRiskOrgnManageMaster([row], true)
            .then((res) => {
              if (res.success) {
                tab2.deleteCallBack([row], this.orgnDatasource)

                tab2.gridInit(this.GetDataGrid(this.dxDataGridRef))
                //데이타 재조회

                tab2.btnSearch()
                tab2.$EventBus.$emit('OnsaveAndDeleteMaster')
              }
            })
            .catch((error) => {
              if (error.response && error.response.data) {
                if ([-6020, -6031, -6033].includes(error.response.data.code)) {
                  this.vSnackbar(`${row.orgnOrder}> ${error.response.data.msg}`, 'warn')
                }
              }
            })
            .finally(() => {})
        },
        (current) => {
          this.GetDataGrid(this.dxDataGridRef).cancelEditData()
        },
        true
      )
    },

    ///////////////////////////////////////
    /*        DataGrid Event Event       */
    ///////////////////////////////////////
    //행 cell에서 데이터 수정후 저장을 누르면 선택된 데이터가 없다는 메세지가 발생
    //위 문제를 해결하기 위해서 아래 소스코드 구현
    onEditingStart(e) {
      if (this.orgnDatasource.length <= 0) return
      if (this.enableEditColumn.indexOf(e.column.dataField) < -1 || e.key == this.highestOrgnVersion.orgnOrder) {
        ////console.log('e.cancel = true')
        e.cancel = false
      } else e.cancel = true
    },
    onEditorPreparing(e) {
      if (e.parentType == 'dataRow') {
        var valueChanged = this.onCellValueChanged
        e.editorOptions.onValueChanged = (args) => {
          if (e.index > -1) valueChanged(args.value, e)
        }
      }
    },
    onCellValueChanged(value, cellInfo) {
      let findData = this.orgnDatasource.find((el) => el.orgnOrder === cellInfo.row.data.orgnOrder)
      findData.orgnOrderNm = value
      // cellInfo.setValue(value)
      // this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
    },
    onFocusedRowChanged(e) {
      if (e.row) this.DataGrids[0].selectRows(e.row.key)
    },
    onRowUpdating(e) {
      var datagrid = this.GetDataGrid(this.dxDataGridRef)
      datagrid.selectRows(e.key, true)
      //this.fileGridData.saveEditData()
    },
    onCheckValueChanged(value, cellInfo) {
      var datagrid = this.GetDataGrid(this.dxDataGridRef)
      //1.다이아그램 조직 정보가 존재하지 않는다면
      //2. 신규 row 추가면
      //=>확정할 수 없도록 처리

      if (cellInfo.column.dataField == 'confirmYn' && cellInfo.value === 'N') {
        ////console.log(cellInfo.row.cells[0]) //
        if (cellInfo.data.__created__ == true) {
          alert('신규데이타는 확정할 수 없습니다.')
          return
        }
      }
      if (cellInfo.data != this.highestOrgnVersion) {
        return
      }
      cellInfo.setValue(cellInfo.value === 'Y' ? 'N' : 'Y')
      datagrid.selectRows(cellInfo.key, true)
      cellInfo.component.updateDimensions()
    },

    deleteCallBack(selectedRows, datasource) {
      var index = null

      if (datasource == undefined) return
      selectedRows.forEach((key) => {
        index = datasource.findIndex((obj) => obj.orgnOrder == key.orgnOrder)
        // this.orgnDatasource.splice(index, 1)
        datasource.splice(index, 1)
      })
    },

    ///////////////////////////////////////
    /*        ETC Event Event       */
    ///////////////////////////////////////
    btnMoveOrgnVerlick(cellInfo) {
      this.vToastifyPrompt(
        // '편집중인 조직구성도가 있다면 초기화됩니다. 그래도 이동하시겠습니까?',
        `${cellInfo.row.key}> 조직도 화면으로 이동하시겠습니까?`,
        'info',
        (current) => {
          this.selectedOrgnVersion = cellInfo.row.key
          //this.selectedTab = '1'

          this.$emit('moveToTabPage', this.selectedOrgnVersion, this.selectedTab)
        },
        null,
        false
      )
    },
    parseTime(val, isDisplay) {
      return val && isDisplay ? `${val.substring(0, 4)}.${val.substring(5, 7)}.${val.substring(8, 10)} ${val.substring(10, 19)}` : ''
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .active_tab {
  border-radius: 5px;
  color: black;
  font-weight: bold !important;
  background-color: #e0e7e9;
  height: 30px;
}

::v-deep .v-tabs-slider-wrapper {
  display: block !important;
  top: 37px;
}

::v-deep .v-slide-group__content {
  align-items: center !important;
}

//
#diagram {
  height: 725px;
}

.dx-popup-content {
  padding: 0;
}

.dx-popup-content .dx-fieldset.buttons {
  display: flex;
  justify-content: flex-end;
}

.dx-popup-content .dx-fieldset.buttons > * {
  margin-left: 8px;
}

::v-deep .menuable__content__active {
  z-index: 2000 !important ;
}

::v-deep #diagram > .dx-overlay-wrapper > .dx-overlay-content {
  left: 700px;
}

.displayNone {
  .dx-accordion-item-opened > .dx-accordion-item-body {
    display: none !important;
  }
}
</style>
